import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';

import { DEFAULT_VALIDATE_FAIL } from './config';

export const isValidFormat = (value: string) => {
    /**
     * (4 числа)(любой символ как сепаратор)(6 чисел)
     * Примеры:
     * 1234 567890
     * 1234-567890
     */

    return /(\d{4})(\D)(\d{6})/.test(value);
};

const validateFormatPassport = (customMessage?: string) => (value?: string) => {
    return value ? validate(isValidFormat(value), DEFAULT_VALIDATE_FAIL, customMessage) : undefined;
};

export const validatePassport = (message?: string) => {
    const validators = [validateNotEmpty(), validateFormatPassport(message)];

    return composeValidators(...validators);
};
